export default class DocumentsATelechargerAccordion {
    constructor() {
        this.accordions = document.querySelectorAll(".documents-a-telecharger");
        this.init();
    }

    init() {
        this.accordions.forEach((accordion) => {
            const accordionRows = accordion.querySelectorAll('.accordion-row');

            accordionRows.forEach((row) => {
                const header = row.querySelector('.accordion-header');
                const content = row.querySelector('.accordion-content');
                
                const hasHiddenBtn = row.classList.contains('buttons-hidden');
                const isCollapsed = row.classList.contains('collapsed');

                const headerChilrenMargin = window.getComputedStyle(header.firstElementChild).marginBottom;

                if (hasHiddenBtn) {
                    row.classList.add('open');
                    row.style.setProperty('--height', `calc(${content.scrollHeight + header.clientHeight}px + ${headerChilrenMargin} + 36px)`);
                    // Disable clicking on the header
                    header.style.pointerEvents = 'none';
                }

                if (isCollapsed) {
                    row.style.setProperty('--height', `calc(${header.clientHeight}px + ${headerChilrenMargin} + 18px)`);
                } else {
                    row.classList.remove('collapsed');
                    row.style.setProperty('--height', `calc(${content.scrollHeight + header.clientHeight}px + ${headerChilrenMargin} + 36px)`);
                }
                

                // Add click event listener to toggle
                header.addEventListener('click', () => {
                    if (row.classList.contains('open')) {
                        // Collapse the row
                        row.classList.remove('open');
                        row.classList.add('collapsed');
                        row.style.setProperty('--height', `calc(${header.clientHeight}px + ${headerChilrenMargin} + 18px)`);
                    } else {
                        // Expand the row
                        row.classList.remove('collapsed');
                        row.classList.add('open');
                        row.style.setProperty('--height', `calc(${content.scrollHeight + header.clientHeight}px + ${headerChilrenMargin} + 36px)`);
                    }
                });
            });
        });
    }
}